var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7088 17.0928L14.4016 12.7856C15.4386 11.4052 15.9984 9.72482 15.9965 7.99824C15.9965 3.58804 12.4084 0 7.99824 0C3.58804 0 0 3.58804 0 7.99824C0 12.4084 3.58804 15.9965 7.99824 15.9965C9.72482 15.9984 11.4052 15.4386 12.7856 14.4016L17.0928 18.7088C17.3109 18.9037 17.5952 19.0077 17.8876 18.9996C18.1799 18.9914 18.458 18.8716 18.6648 18.6648C18.8716 18.458 18.9914 18.1799 18.9996 17.8876C19.0077 17.5952 18.9037 17.3109 18.7088 17.0928ZM2.28521 7.99824C2.28521 6.86831 2.62027 5.76375 3.24803 4.82425C3.87579 3.88475 4.76804 3.1525 5.81196 2.72009C6.85588 2.28768 8.00458 2.17455 9.1128 2.39499C10.221 2.61542 11.239 3.15954 12.038 3.95852C12.8369 4.7575 13.3811 5.77546 13.6015 6.88368C13.8219 7.9919 13.7088 9.1406 13.2764 10.1845C12.844 11.2284 12.1117 12.1207 11.1722 12.7484C10.2327 13.3762 9.12817 13.7113 7.99824 13.7113C6.48361 13.7094 5.03153 13.107 3.96053 12.036C2.88952 10.9649 2.28703 9.51287 2.28521 7.99824Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGray);
export default __webpack_public_path__ + "static/media/SearchGray.780bf56e37fe29048314c5b0175b84b7.svg";
export { ForwardRef as ReactComponent };